import { useParams } from 'react-router-dom';
import { CloseCircleOutlined, PlayCircleTwoTone } from '@ant-design/icons';
import { Button, Form, message, Popconfirm } from 'antd';

import { initProductSuccessAction, IProductStore, productStore } from 'containers/Products/Product/store';

import { usePatchRequest } from 'hooks';

import { ProductDetails } from 'codegen';
import { RecursiveRequired } from 'types';

const { useFormInstance } = Form;

export const PublishProductBtn = ({ disabled }: { disabled: boolean }) => {
  const status = productStore((state) => state.status);
  const identities = productStore((state) => state.identities);
  const effectivePeriods = productStore((state) => state.initialValues.effectivePeriods);

  const form = useFormInstance<RecursiveRequired<IProductStore['initialValues']>>();

  const { productId } = useParams();

  const [toggleProduct, { loading }] = usePatchRequest<ProductDetails>({
    url: `/products/details/${productId}/activation`,
    options: {
      onSuccess: ({ data }, [params]) => {
        const type = params.url.includes('isActive=true') ? 'published' : 'unpublished';

        initProductSuccessAction(data);
        message.success(`Product successfully ${type}!`);
      },
    },
  });

  const isShowPublishBtn = status === ProductDetails.status.DRAFT && !!identities?.length;
  const isShowUnpublishBtn = status !== ProductDetails.status.DRAFT && !!identities?.length;

  if (isShowPublishBtn) {
    return (
      <Popconfirm
        title={(
          <div className='w-[200px]'>
            Are you sure you want to publish this product?
          </div>
        )}
        okText='Publish'
        cancelText='No'
        placement='bottom'
        disabled={form?.isFieldsTouched() || !effectivePeriods?.length || disabled}
        onConfirm={() => toggleProduct({ callbackQueryParams: { isActive: true } })}
      >
        <Button
          icon={<PlayCircleTwoTone twoToneColor={form?.isFieldsTouched() ? '#b8b8b8' : ''} />}
          loading={loading}
          disabled={form?.isFieldsTouched() || !effectivePeriods?.length || disabled}
        >
          Publish Product
        </Button>
      </Popconfirm>
    );
  }

  if (isShowUnpublishBtn) {
    return (
      <Popconfirm
        title={(
          <div className='w-[200px]'>
            Are you sure you want to unpublish this product?
          </div>
        )}
        okText='Unpublish'
        cancelText='No'
        placement='bottom'
        disabled={form?.isFieldsTouched() || disabled}
        onConfirm={() => toggleProduct({ callbackQueryParams: { isActive: false } })}
      >
        <Button
          danger
          icon={<CloseCircleOutlined twoToneColor={form?.isFieldsTouched() ? '#b8b8b8' : ''} />}
          loading={loading}
          disabled={form?.isFieldsTouched() || disabled}
        >
          Unpublish Product
        </Button>
      </Popconfirm>
    );
  }

  return null;
};
